import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Divisions from "@/components/sections/Divisions";
import Membership from "@/components/sections/Membership";
import OnDemand from "@/components/sections/OnDemand";
import WhyCamo from "@/components/sections/WhyCamo";
import FinalCTA from "@/components/sections/FinalCTA";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-black text-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Divisions />
        <Membership />
        <OnDemand />
        <WhyCamo />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
